export interface Service {
  title: string
  description: string
  icon: 'heart' | 'heartHandshake' | 'sparkles' | 'shield' | 'scroll' | 'users'
  image: string
  imageAlt: string
}

export const services: Service[] = [
  {
    title: 'Amarre por Amor',
    description:
      'Práctica espiritual tradicional enfocada en situaciones sentimentales y de pareja. Ofrecemos orientación personalizada de acuerdo con cada situación. Los resultados pueden variar según cada persona.',
    icon: 'heart',
    image: 'https://cdn.magicpatterns.com/uploads/uRX6CedXB8JmZXbNHwqigS/image.png',
    imageAlt: 'Pareja conversando sentada junto al mar al atardecer',
  },
  {
    title: 'Amarre del Mismo Sexo',
    description:
      'Práctica espiritual tradicional relacionada con situaciones sentimentales. Ofrecemos orientación personalizada de acuerdo con cada situación.',
    icon: 'heartHandshake',
    image: 'https://cdn.magicpatterns.com/uploads/j2JqEWWbE3CVojNmXGAfxQ/image.png',
    imageAlt: 'Pareja compartiendo un momento de cercanía y afecto',
  },
  {
    title: 'Atraer Prosperidad',
    description:
      'Práctica espiritual enfocada en la reflexión personal, las metas y la prosperidad. Los resultados pueden variar según cada persona.',
    icon: 'sparkles',
    image: 'https://cdn.magicpatterns.com/uploads/hxVz4WkrnscmTvqN2pCDT8/image.png',
    imageAlt: 'Billetes con una pequeña bandera de Estados Unidos',
  },
  {
    title: 'Alejamientos y Dominios',
    description:
      'Prácticas espirituales tradicionales relacionadas con situaciones personales y relaciones interpersonales.',
    icon: 'shield',
    image: 'https://cdn.magicpatterns.com/uploads/fVKXurGrayKC5LiYpfEBPJ/image.png',
    imageAlt: 'Mujer recogida en un banco, en un momento de introspección',
  },
  {
    title: 'Pactos',
    description:
      'Pactos y rituales espirituales tradicionales, realizados de manera personalizada según cada situación.',
    icon: 'scroll',
    image: 'https://cdn.magicpatterns.com/uploads/2beC8WU1DD3EviDgJ69Nwj/image.png',
    imageAlt: 'Mesa ritual tradicional con piedras, huesos y elementos ceremoniales',
  },
  {
    title: 'Unión Familiar',
    description:
      'Orientación espiritual relacionada con situaciones familiares y personales. Cada consulta se adapta a las circunstancias particulares de cada persona.',
    icon: 'users',
    image: 'https://cdn.magicpatterns.com/uploads/o7z24PQPJ9S69G4pYpoAsW/image.png',
    imageAlt: 'Familia preparando el desayuno junta en la cocina',
  },
]

export interface Benefit {
  title: string
  description: string
  icon: 'compass' | 'handshake' | 'moon' | 'lock'
}

export const benefits: Benefit[] = [
  {
    title: 'Orientación personalizada',
    description: 'Escuchamos tu situación y adaptamos la consulta a tus circunstancias particulares.',
    icon: 'compass',
  },
  {
    title: 'Atención cercana',
    description: 'Trato humano y respetuoso, con acompañamiento durante todo el proceso de consulta.',
    icon: 'handshake',
  },
  {
    title: 'Experiencia en prácticas tradicionales',
    description: 'Trabajamos con prácticas y rituales espirituales de tradición, explicados con claridad.',
    icon: 'moon',
  },
  {
    title: 'Consultas confidenciales',
    description: 'Tu información y tu consulta se tratan de manera privada y reservada.',
    icon: 'lock',
  },
]

export interface Testimonial {
  quote: string
  author: string
  meta: string
  avatar: string
}

export const testimonials: Testimonial[] = [
  {
    quote: 'Me sentí escuchada y recibí una orientación muy clara sobre mi situación.',
    author: 'Carolina M.',
    meta: 'Miami, FL',
    avatar:
      'https://cdn.magicpatterns.com/patterns/generated-images/17e2653f-6e87-479f-9ee3-067acf2e24a7.jpg',
  },
  {
    quote: 'Me explicaron el proceso y respondieron todas mis preguntas.',
    author: 'Jorge A.',
    meta: 'Hialeah, FL',
    avatar:
      'https://cdn.magicpatterns.com/patterns/generated-images/956b406f-2d66-4543-b6cb-3ff672c31411.jpg',
  },
  {
    quote: 'La atención fue amable y personalizada.',
    author: 'Daniela R.',
    meta: 'Fort Lauderdale, FL',
    avatar:
      'https://cdn.magicpatterns.com/patterns/generated-images/6b85b6e4-a56a-4f8c-8b6c-779fcc356e7a.jpg',
  },
]
